import { render, staticRenderFns } from "./checkboxItemDialog.vue?vue&type=template&id=66113f00&scoped=true"
import script from "./checkboxItemDialog.vue?vue&type=script&lang=js"
export * from "./checkboxItemDialog.vue?vue&type=script&lang=js"
import style0 from "./checkboxItemDialog.vue?vue&type=style&index=0&id=66113f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66113f00",
  null
  
)

export default component.exports